import { gql } from "@apollo/client";

export default gql`
  query getTalentIndicatorTrends(
    $organizationId: Int!
    $talentIndicatorId: Int!
    $teamIds: [Int!]
    $managerIds: [Int!]
    $reportType: TrendReportType!
    $groupBy: TrendReportGroupBy
    $startDate: Date
    $endDate: Date
  ) {
    trendReport(
      organizationId: $organizationId
      talentIndicatorId: $talentIndicatorId
      teamIds: $teamIds
      managerIds: $managerIds
      reportType: $reportType
      groupBy: $groupBy
      startDate: $startDate
      endDate: $endDate
    ) {
      name
      data {
        key
        value
        count
      }
    }
  }
`;
